import getPublisherDistributionPresets from "../distribution/utils/getPublisherDistributionPresets";

import articlePublicationStatuses from "./constants/articlePublicationStatuses";

const articlePublicationStatusPriority = [
	articlePublicationStatuses.PUBLISHED,
	articlePublicationStatuses.ANNOUNCED,
	articlePublicationStatuses.UNPUBLISHED,
	articlePublicationStatuses.NOT_PUBLISHED,
];

function getHighestPriorityStatus(statuses) {
	return (
		articlePublicationStatusPriority.find((status) => statuses.includes(status)) ||
		articlePublicationStatuses.NOT_PUBLISHED
	);
}

export default function getPublicationStatusByPriority({ article, publisher }) {
	// A disabled preset means that channel's status is stale (e.g. a publisher that dropped a metadata channel) and
	// shouldn't count (For example the publishers that moved from metadata channels to NFG)
	const enabledPresetChannelIds = new Set(
		getPublisherDistributionPresets({ article, publisher }).map((preset) => preset.channel.id),
	);

	const allChannels = Object.values(article.channels || {});
	const enabledChannels = Object.entries(article.channels || {})
		.filter(([channelId]) => enabledPresetChannelIds.has(channelId))
		.map(([, channelData]) => channelData);

	// Nothing left to count if every preset is disabled - fall back to all channels rather than NOT_PUBLISHED
	const channels = enabledChannels.length > 0 ? enabledChannels : allChannels;

	// Metadata channels take priority when present, so an enabled artifact-only channel (e.g. Axiell) can't keep a
	// taken-down article PUBLISHED. With no metadata channels at all, every channel counts.
	const metadataChannels = channels.filter((channel) => channel?.delivery?.metadata?.sent);
	const prioritizedChannels = metadataChannels.length > 0 ? metadataChannels : channels;

	return getHighestPriorityStatus(prioritizedChannels.map((channel) => channel?.publicationStatus));
}
